import {api} from '../components/Base/App';

export default {
    getConfiguration(locale) {
        return api({
            method: 'get',
            url: '/rest/api/configuration/',
            params: {
                locale: locale
            }

        });
    }


}



// WEBPACK FOOTER //
// ./src/api/Configuration.js